import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";
import { makeDefaultFilters } from "../../../utils/default-filters";

import type { FC } from "react";

export const RecentlyEditedSection: FC = () => (
  <Box component="section">
    <Box display="flex" alignItems="center" justifyContent="space-between" gap={2} flexWrap="wrap">
      <Typography variant="h6" component="h2">
        Recently edited
      </Typography>
      <Box display="flex" gap={3}>
        <Link
          component={RouterLink}
          to={`/calendars/schedule?${makeDefaultFilters().toString()}`}
          variant="subtitle2"
          underline="hover"
          data-analytics-id="dashboard-recently-edited-upcoming-sends"
        >
          Upcoming Sends
        </Link>
        <Link
          component={RouterLink}
          to="/moments/history"
          variant="subtitle2"
          underline="hover"
          data-analytics-id="dashboard-recently-edited-sent-communications"
        >
          Sent Communications
        </Link>
      </Box>
    </Box>
  </Box>
);
